import theme from '@ifca-root/react-component/src/assets/theme';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import TextSeparator from '@ifca-root/react-component/src/components/Typography/TextSeparator';
import { Box, Divider, Grid, useMediaQuery } from '@material-ui/core';
import Accordion from '@material-ui/core/ExpansionPanel';
import { AccordionDetails } from '@material-ui/core';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import ShareIcon from '@material-ui/icons/Share';
import { Auditor } from 'assets';
import { DynamicFooter } from 'components/Footer/DynamicFooter';
import {
	useGetExportedStatisticDetailsLazyQuery,
	useGetOutletQuery,
	useGetUsersByAccountQuery,
	// useMenuAccountXListQuery,
} from 'generated/graphql';
import { formatDate } from 'helpers/hooks/formatDate';
import * as htmlToImage from 'html-to-image';
import React, { Reducer, useEffect, useReducer, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useHistory, useLocation } from 'react-router';
import '../../AccountJournalsModule/GeneralLedgerJournal/generalLedger.scss';
import * as _ from 'underscore';
import { IAction } from 'helpers/model';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';

interface Props {
  Dialog?: boolean
  ImageUrl?: string
  STDetailsData?: any
}


export const StatisticTransactionDetail = () => {
	useEffect(() => {
		console.log('StatisticTransactionDetail');
	}, []);

	const history = useHistory();
	const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
		defaultMatches: true,
	});

	const outletID = localStorage.getItem('latestOutlet');
	const user = JSON.parse(localStorage.getItem('loggedInUser'));

	const { state: detailState }: any = useLocation();

	var dateFormat = require('dateformat');
	const initialState: Props = {
		Dialog: false,
		ImageUrl: '',
		STDetailsData: [],
	}

		const {
				data: { getUsersByAccount } = { getUsersByAccount: [] },
			} = useGetUsersByAccountQuery({
				variables: {
					accountID: user?.accountID,
				},
				fetchPolicy: 'network-only',
		});
		
	const createdByName = ID => {
		return getUsersByAccount?.find(x => x.ID === ID)?.name || ''
	}
	const reducer: Reducer<Props, IAction> = (state, action) => {
		switch (action.type) {
			case 'reset':
				return initialState
			default:
				return { ...state, [action.type]: action.payload }
		}
	}
  const [state, dispatch] = useReducer(reducer, initialState)	
	
	console.log(state,'state')
	const {
		called: ouletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});
	
	const [
    getExportedStatisticQuery, 
    { 
      loading: statisticLoading, 
      data: { getExportedStatisticDetails } = { getExportedStatisticDetails: [] } 
    }
  ] = useGetExportedStatisticDetailsLazyQuery({
    fetchPolicy: 'no-cache',
		variables: {
			outletID: outletID,
			accountID: JSON.parse(localStorage.getItem('loggedInUser'))?.accountID,
			batchNo: Number(detailState?.batchNo),
		},
  })

	useEffect(() => {

    getExportedStatisticQuery({
        variables: {
          outletID: localStorage.getItem('latestOutlet'),
          accountID: JSON.parse(localStorage.getItem('loggedInUser'))?.accountID,
          batchNo: Number(detailState.batchNo),
        }
      })

  }, [])


	useEffect(() => {
    if (getExportedStatisticDetails?.length > 0)
      dispatch({
        type: 'STDetailsData',
        payload: getExportedStatisticDetails,
      })
  }, [getExportedStatisticDetails])

	console.log(getExportedStatisticDetails,'getExportedStatisticDetails')

	const ExportCSVData =
			getExportedStatisticDetails?.map(x => ({
					JournalTypeName: 'MXST',
					DocNo: '',
					JournalDate: `${dateFormat(x?.statisticDate, 'dd/mm/yyyy')}`,
					Description: `MXST-${x?.description}`,
					AccountName: '',
					MasterCOACode: x?.accountCode,
					DepartmentCode: `${x?.division === null || x?.division === "" ? 'DIV' : x?.division}${x?.department === null || x?.department === "" ? 'DEP' : x?.department}`,
					Amount: x?.amount,
					Remark: '',		
			  }))


	const csvRef = useRef(null);

	const handleGlExport = async () => {
		csvRef.current.link.click();
	};


 const Display = (hidden?: boolean) => {
		return (
			<div
				style={
					hidden
						? {
								zIndex: -40,
								top: 0,
								left: 0,
								position: 'fixed',
								width: '100%',
						  }
						: {
								marginTop: '0px',
								zIndex: 40,
								position: 'relative',
						  }
				}
				className={hidden ? 'hidden-content' : null}
			>
				<div
					id={!hidden ? 'gl ' : 'hiddenCB'}
					style={
						hidden
							? { marginTop: '-85px', width: '100%', height: '100%' }
							: { width: '100%', height: '100%' }
					}
				>

				</div>
			</div>
		);
	};

	return (
		<>
			{outletLoading && <Loading />}
			{statisticLoading && <Loading />}

			<MainHeader
				mainBtn="back"
				onClick={() => {
					history.push({
						pathname: `/menu/outlet-app/account-journals/statistic-transaction`,
					});
				}}
				smTitle="Outlet App"
				title={getOutlet[0]?.name}
				routeSegments={[
					{ name: 'Account Journals' },
					{ name: 'Statistic Transaction' },
					{ name: 'Statistic Transaction', current: true },
				]}
			/>
			{console.log(detailState,'detailState')}
			<DynamicSubHeader
				style={{ top: '63px' }}
				title={
					<span className="xsTitle" style={{ color: 'orange' }}>
						{formatDate(detailState.Date)}
					</span>
				}
				
				infoLine={
						<div>
							<span className="desc icon-text">
								<span style={{ color: '#ff9800' }}>
									{detailState.transactionCount}
								</span>
								&nbsp; transactions <TextSeparator />
								<span  >
									{createdByName(detailState.createdBy)}
								</span>
								&nbsp;<TextSeparator />
								<img
									src={Auditor}
									alt="ifca"
									width={12}
									loading="lazy"
									style={{ paddingRight: '4px' }}
								/>
								<span className="desc icon-text">
									{formatDate(detailState.createdTs)}{' '}
								</span>
							</span>
						</div>
				}
			/>

			{Display()}
			{Display(true)}

			<ContentWrapper
						style={{
							marginTop: isDesktop ? '152px' : '86px',
						}}
					>
									<Accordion className="accordion-card" >
										<AccordionSummary
											expandIcon={<ExpandMoreIcon />}
											aria-controls="panel1a-content"
											id="panel1a-header"
										>
											<Grid container justifyContent="flex-start">
												<Grid
													item
													xs={6}
													className="xsTitle"
													style={{
														whiteSpace: 'normal',
													}}
												>
													Statistic
												</Grid>
											</Grid>
										</AccordionSummary>
										{state?.STDetailsData?.map((trx, index) => (
										<AccordionDetails>
											<Grid
											key={index}
												container
												justifyContent="flex-start"
												className="desc"
												style={{ width: '96%', padding: '4px' }}
											>
												<Grid item xs={5} className="desc" style={{ display: 'flow', padding: '4px' }}>
													{trx?.description}
												</Grid>
												<Grid item xs={5} className="desc" style={{ display: 'flow', padding: '4px' }}>
													{trx?.department } / {trx?.division } / {trx?.accountCode}
												</Grid>
												<Grid
                          item
                          xs={2}
                          className="desc"
                          style={{ display: 'flex', justifyContent: 'end', padding: '4px' }}
                        >
                          {trx?.amount}
                        </Grid>
												
											</Grid>
											<Divider variant="fullWidth" className="flex" />
										</AccordionDetails>
										))}
									</Accordion>
					</ContentWrapper>

			<CSVLink
				filename={`statistic_Export_${formatDate(detailState.Date)}.csv`}
				data={ExportCSVData}
				ref={csvRef}
			/>

			<DynamicFooter
				options={[
					{
						name: 'Download',
						onClick: () => handleGlExport(),
						color: 'primary',
						startIcon: <ShareIcon />,
					},
				]}
			/>
		</>
	);
};
